/* eslint-disable no-unused-expressions */
const myModalApp = angular.module('inspinia');

myModalApp.directive('baseModalHeader', () => {
  return {
    templateUrl: `/manage/src/view/directive/base_modal_header.html?${new Date().getTime()}`,
    replace: true,
    restrict: 'E',
    scope: { title: '@', showCloseButton: '&?', onClose: '&' },
    link($scope) {
      $scope.showCloseButton = $scope.showCloseButton ?? (() => true);
    },
  };
});
